import dayjs from 'dayjs';

/** ScheduledStudentStartService::INVITE_LEAD_DAYS. */
export const INVITE_LEAD_DAYS = 3;

/**
 * When the parent's app invite actually goes out for a given start date.
 *
 * The sweep selects `start_date <= today + INVITE_LEAD_DAYS` and runs once a
 * day at 09:00 school-local, so the lead is a CEILING rather than a promise:
 * a child starting tomorrow is already inside the window and their invite
 * goes at the next daily send, not three days ago.
 *
 * Saying "sent 3 days before they start" for such a child is simply wrong,
 * and it is wrong precisely where an administrator is most likely to be
 * looking — adding a child who starts imminently.
 *
 * Returns `{ immediate, day }`. `day` is the date the invite is due and is
 * null when it is already due; callers name it rather than making the reader
 * subtract three days themselves.
 */
export const inviteTiming = (startDate) => {
	if (!startDate) return { immediate: false, day: null };

	const due = dayjs(startDate).subtract(INVITE_LEAD_DAYS, 'day');

	// `isAfter(..., 'day')` and not a timestamp compare: both sides are
	// calendar dates, and the sweep decides on the school's date too.
	return due.isAfter(dayjs(), 'day') ? { immediate: false, day: due } : { immediate: true, day: null };
};

/**
 * The invite half of the enroll form's and the profile banner's helper line,
 * as one sentence. Shared so the two cannot drift.
 */
export const inviteSentence = (startDate) => {
	const { immediate, day } = inviteTiming(startDate);

	return immediate
		? `They start within ${INVITE_LEAD_DAYS} days, so the parent's app invite goes out at the next daily send.`
		: `The parent's app invite is sent on ${day.format('MMM D')}, ${INVITE_LEAD_DAYS} days before they start.`;
};
